import * as React from "react";
import { renderSportIcon } from "./renderSportIcon";
import { renderGameState } from "./renderGameState";
export const renderGameStateWrapper = (props, componentPrefix) => props.isDesktop
    ? renderGameStateDesktop(props, componentPrefix)
    : renderGameStateMobile(props, componentPrefix);
const renderGameStateDesktop = (props, componentPrefix) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`, "data-uat": `div-ev-list-${componentPrefix}-clock` },
    renderSportIcon(props.event.sportId, componentPrefix),
    !props.hideGameState && renderGameState(props, componentPrefix));
const renderGameStateMobile = (props, componentPrefix) => !props.hideGameState && !props.event.isInKickOffState && renderGameState(props, componentPrefix);
//# sourceMappingURL=renderGameStateWrapper.js.map